import { LocationItem } from '../Card';
import React from 'react';

import { ActivityItemsFragment } from '../../generated/graphql';
import { activityItemRoute } from '../../helpers/routes';
import { ItemProps } from './common';
import { resizeImageW } from '../../helpers/mediaApiUrls';
import { PageItemLink } from '../PageItemLink';

const Activity: React.FC<ItemProps> = ({ item, page, className, dragProps, preview }) => {
  const activity = item as ActivityItemsFragment;
  const photoPath = resizeImageW(activity.photo?.mediaUrl, 145);

  return (
    <PageItemLink
      to={activityItemRoute(page.id, activity.id, preview)}
      page={page}
      pageItem={item}
      data-testid={`activity-item-${activity.id}`}
    >
      <LocationItem
        header="Activity"
        name={activity.name}
        address={activity.address}
        description={activity.description}
        website={activity.website}
        phone={activity.phone}
        photoPath={photoPath}
        email={activity.email}
        className={className}
        {...dragProps}
      />
    </PageItemLink>
  );
};

export default Activity;
